export interface IGetLocationsFiltersDto {
    includeExternal?: boolean;
    includeSharedFinished?: boolean;
}
